(() => {
  if (window.__ecCartEdit) return;
  window.__ecCartEdit = true;

  const ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const PAIR_KEYS = ['Power R', 'Power L', '_pair', '_pair_id', '_eye'];
  let session = null;
  let uid = 0;

  const t = (k) => {
    const el = document.querySelector('script[data-ec-cart-edit-i18n]');
    return (el && el.getAttribute('data-' + k)) || '';
  };

  const modalEl = () => document.querySelector('[data-quick-view-modal]');

  const getCart = () => fetch(ROOT() + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());

  const postJSON = async (path, body) => {
    const res = await fetch(ROOT() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error('cart request failed');
      err.userMessage = typeof data.description === 'string' && data.description ? data.description : '';
      throw err;
    }
    return data;
  };

  const handleOf = (url) => {
    const m = /\/products\/([^/?#]+)/.exec(url || '');
    return m ? decodeURIComponent(m[1]) : '';
  };

  const withVariant = (url, id) => url.split('?')[0] + '?variant=' + id;

  const sameProps = (a, b) => {
    const ka = Object.keys(a || {}), kb = Object.keys(b || {});
    if (ka.length !== kb.length) return false;
    return ka.every((k) => String(a[k]) === String((b || {})[k]));
  };

  const visibleProps = (props) => Object.keys(props || {}).filter((k) => k.charAt(0) !== '_' && props[k] !== '' && props[k] != null);

  const sellingPlan = (line) => line.selling_plan_allocation && line.selling_plan_allocation.selling_plan
    ? line.selling_plan_allocation.selling_plan.id : null;

  const start = async (btn) => {
    if (session && session.busy) return;
    if (typeof window.r$1 !== 'function') return;

    const key = btn.getAttribute('data-ec-cart-edit');
    const mode = btn.getAttribute('data-ec-cart-edit-mode');
    const url = btn.getAttribute('data-ec-cart-edit-url') || '';
    const cart = await getCart();
    const line = cart.items.find((i) => i.key === key);
    if (!line) return;

    const s = {
      key, mode, line, cart,
      ctx: btn.closest('.quick-cart') ? 'drawer' : 'page',
      free: btn.hasAttribute('data-ec-cart-edit-free'),
      href: window.location.href,
      handle: handleOf(url) || line.handle,
      applied: false,
      busy: false
    };

    let openId = line.variant_id;

    if (mode === 'pair') {
      const props = line.properties || {};
      const pid = props._pair_id;
      const hasPid = pid !== undefined && pid !== null && pid !== '';
      const group = hasPid
        ? cart.items.filter((i) => i.properties && String(i.properties._pair_id) === String(pid))
        : [line];
      const rLines = group.filter((i) => i.properties._eye === 'R');
      const lLines = group.filter((i) => i.properties._eye === 'L');
      let qty;
      if (hasPid) {
        qty = rLines.length ? rLines.reduce((n, i) => n + i.quantity, 0) : Math.round(group.reduce((n, i) => n + i.quantity, 0) / 2);
      } else {
        qty = Math.max(1, Math.round(line.quantity / 2));
      }
      s.pair = {
        pid: hasPid ? pid : null,
        group,
        base: rLines[0] || line,
        rId: (rLines[0] || line).variant_id,
        lId: (lLines[0] || line).variant_id,
        qty: Math.max(1, qty)
      };
      openId = s.pair.rId;
    }

    s.doc = fetch(withVariant(url || line.url, openId))
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => (html ? new DOMParser().parseFromString(html, 'text/html') : null))
      .catch(() => null);

    session = s;
    window.r$1('quick-view:open', null, { productUrl: withVariant(url || line.url, openId) });
  };

  const setSelect = (sel, value) => {
    let opt = Array.from(sel.options).find((o) => o.value === value);
    if (!opt) {
      opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      sel.insertBefore(opt, sel.firstChild);
    }
    sel.value = value;
  };

  const injectRx = (s, doc) => {
    if (!doc || session !== s || !s.root) return;
    const props = s.line.properties || {};
    const names = visibleProps(props);
    const pdpSelects = Array.from(doc.querySelectorAll('select[data-custom-option-input]'));
    const containers = [];
    names.forEach((n) => {
      const sel = pdpSelects.find((el) => el.getAttribute('name') === n);
      if (!sel) return;
      const c = sel.closest('.multiple-option-container') || sel.closest('.product__controls-group');
      if (c && containers.indexOf(c) === -1) containers.push(c);
    });
    if (!containers.length) return;
    containers.sort((a, b) => (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1));

    const wrap = document.createElement('div');
    wrap.setAttribute('data-ec-cart-edit-fields', '');
    containers.forEach((c) => {
      const clone = document.importNode(c, true);
      clone.querySelectorAll('script, style').forEach((el) => el.remove());
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      clone.querySelectorAll('select[data-custom-option-input]').forEach((sel) => {
        const n = sel.getAttribute('name');
        const group = sel.closest('.product__controls-group');
        if (!Object.prototype.hasOwnProperty.call(props, n)) {
          if (group) group.remove();
          return;
        }
        const id = 'ec-cart-edit-' + (++uid);
        sel.removeAttribute('data-custom-option-input');
        sel.removeAttribute('name');
        sel.id = id;
        sel.setAttribute('data-ec-cart-edit-prop', n);
        if (group) {
          const label = group.querySelector('label.product__label');
          if (label) label.setAttribute('for', id);
          const labelWrap = group.querySelector('.product__label-wrapper.hidden');
          if (labelWrap) labelWrap.classList.remove('hidden');
        }
        setSelect(sel, String(props[n]));
        const sw = sel.closest('.select-wrapper');
        if (sw && !sw.querySelector('.icon-chevron-small')) {
          const src = doc.querySelector('.select-wrapper .icon-chevron-small') || document.querySelector('.select-wrapper .icon-chevron-small');
          if (src) {
            const ic = document.importNode(src, true);
            ic.classList.remove('hidden');
            const none = sw.querySelector('.icon-none');
            if (none) sw.replaceChild(ic, none); else sw.appendChild(ic);
          }
        }
      });
      clone.querySelectorAll('[data-custom-option-input]').forEach((el) => {
        const group = el.closest('.product__controls-group');
        if (group) group.remove(); else el.remove();
      });
      if (clone.querySelector('[data-ec-cart-edit-prop]')) wrap.appendChild(clone);
    });
    if (!wrap.children.length) return;

    const inner = s.root.querySelector('.quick-product--right-inner') || s.root;
    const anchor = inner.querySelector('.product__controls-group-quantity');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(wrap, anchor);
    else inner.appendChild(wrap);
  };

  const presetPair = (s, tries) => {
    if (session !== s || !s.root) return;
    const picker = s.root.querySelector('.variant-picker-pairs');
    const sels = picker ? picker.querySelectorAll('select') : [];
    if (!picker || sels.length !== 2) return;
    if (!picker._x_dataStack && tries < 40) {
      setTimeout(() => presetPair(s, tries + 1), 50);
      return;
    }
    [[sels[0], s.pair.rId], [sels[1], s.pair.lId]].forEach(([sel, id]) => {
      sel.value = String(id);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const GIFT_FIXED_OPTION = /power|preference|sph|cyl|axis/i;

  const lockGiftOptions = (root) => {
    root.querySelectorAll('.product__option').forEach((o) => {
      const sel = o.querySelector('select[name^="options["]');
      if (!sel) return;
      const name = (sel.getAttribute('name') || '').replace(/^options\[/, '').replace(/\]$/, '');
      if (sel.options.length > 1 && !GIFT_FIXED_OPTION.test(name)) return;
      o.hidden = true;
    });
  };

  const optionName = (o) => {
    const sel = o.querySelector('select[name^="options["]');
    return sel ? sel.getAttribute('name') || '' : '';
  };

  const addGiftNote = (root) => {
    const text = t('gift-color-note');
    if (!text) return;
    const opts = Array.from(root.querySelectorAll('.product__option'));
    const color = opts.find((o) => optionName(o) === 'options[Color]');
    if (!color || !opts.some((o) => /power|preference|sph/i.test(optionName(o)))) return;
    const note = document.createElement('div');
    note.className = 'product__custom-option-instructions rte rte--product fs-body-75 t-opacity-70';
    note.textContent = text;
    color.appendChild(note);
  };

  const setupButton = (root) => {
    const btn = root.querySelector('[name="add"]');
    if (!btn) return;
    const label = t('confirm');
    btn.setAttribute('data-lang-available', label);
    btn.setAttribute('aria-label', label);
    btn.removeAttribute('onclick');
    const text = btn.querySelector('[data-add-to-cart-text]');
    if (text && !btn.disabled) text.textContent = label;
  };

  const errorEl = () => session && session.root && session.root.querySelector('[data-quantity-error]');

  const showError = (msg) => {
    const el = errorEl();
    if (!el) return;
    el.textContent = msg || t('error');
    el.classList.remove('hidden');
  };

  const clearError = () => {
    const el = errorEl();
    if (el) el.classList.add('hidden');
  };

  const end = () => {
    const s = session;
    if (!s) return;
    session = null;
    const m = modalEl();
    if (m) m.removeAttribute('data-ec-cart-edit-modal');
    if (s.href && window.location.href !== s.href) {
      window.history.replaceState(window.history.state, '', s.href);
    }
  };

  const watchClose = (m, s) => {
    let seenActive = m.classList.contains('active');
    const mo = new MutationObserver(() => {
      if (session !== s) { mo.disconnect(); return; }
      if (m.classList.contains('active')) { seenActive = true; return; }
      if (seenActive) { mo.disconnect(); end(); }
    });
    mo.observe(m, { attributes: true, attributeFilter: ['class'] });
  };

  const placeBadges = (s, header, pdpHeader) => {
    header.querySelectorAll('.badge-beside-review-top, .product-badges').forEach((el) => el.remove());
    const source = pdpHeader.querySelector('.badge-beside-review-top') || pdpHeader.querySelector('.product-badges');
    if (!source || !source.querySelector('.product-badge, p')) return;
    s.root.querySelectorAll('.quick-product--left .product__media, .product__block--product-header-image-wrap .product__media').forEach((slot) => {
      const wrap = document.createElement('div');
      wrap.className = 'new-product-template product__block--product-header-inner ec-cart-edit-badges';
      wrap.appendChild(document.importNode(source, true));
      slot.appendChild(wrap);
    });
  };

  const setupHeader = (s, doc) => {
    const header = s.root.querySelector('.product__block--product-header');
    const pdpHeader = doc.querySelector('.product__meta .product__block--product-header') || doc.querySelector('.product__block--product-header');
    if (!header || !pdpHeader) return;
    placeBadges(s, header, pdpHeader);
    const price = header.querySelector('.product__price');
    const pdpPrice = pdpHeader.querySelector('.product__price');
    if (!price || !pdpPrice) return;
    const clone = document.importNode(pdpPrice, true);
    ['[data-compare-text]', '[data-compare-price]', '[data-price]', '[data-discount-display]'].forEach((sel) => {
      const keep = price.querySelector(sel);
      const fresh = clone.querySelector(sel);
      if (!keep || !fresh) return;
      keep.innerHTML = fresh.innerHTML;
      keep.className = fresh.className;
      fresh.replaceWith(keep);
    });
    price.className = clone.className;
    price.replaceChildren(...Array.from(clone.childNodes));
    price.querySelectorAll('.ec-sale-tag').forEach((el) => el.remove());
    const discount = price.querySelector('[data-discount-display]');
    if (discount && s.mode === 'pair') {
      const markup = discount.innerHTML;
      s.root.querySelectorAll('.variant-picker-pairs select').forEach((sel) => {
        sel.addEventListener('change', () => {
          if (discount.innerHTML.trim()) discount.innerHTML = markup;
        });
      });
    }
    header.querySelectorAll('[variant-discount-display]').forEach((el) => {
      const src = pdpHeader.querySelector('[variant-discount-display][variant-id="' + el.getAttribute('variant-id') + '"]');
      if (src) el.innerHTML = src.innerHTML;
    });
    const row = price.closest('.product__price-and-ratings');
    if (row && !row.parentElement.classList.contains('new-product-template')) {
      const scope = document.createElement('div');
      scope.className = 'new-product-template product__block--product-header-inner';
      scope.appendChild(row);
      header.appendChild(scope);
      const details = header.querySelector('.quick-view-view-product-details-link');
      if (details) scope.appendChild(details);
    }
  };

  document.addEventListener('quickview:loaded', () => {
    const s = session;
    if (!s || s.applied) return;
    const m = modalEl();
    const root = m && m.querySelector('[data-is-quick-view]');
    if (!root) return;
    const form = root.querySelector('form[data-product-handle]');
    if (form && s.handle && form.getAttribute('data-product-handle') !== s.handle) {
      session = null;
      return;
    }
    s.applied = true;
    s.root = root;
    m.setAttribute('data-ec-cart-edit-modal', s.mode);
    watchClose(m, s);
    setupButton(root);
    if (s.mode === 'gift') {
      lockGiftOptions(root);
      addGiftNote(root);
    }
    if (s.mode === 'pair') presetPair(s, 0);
    root.querySelectorAll('.quick-product--right-inner > .product__description').forEach((el) => el.remove());
    const powerLabel = t('power');
    root.querySelectorAll('.product-curve-diameter').forEach((el) => {
      const parts = el.textContent.split('|').map((p) => p.trim()).filter((p) => p && !(powerLabel && p.indexOf(powerLabel) === 0));
      if (parts.length) el.textContent = parts.join(' | ');
      else el.remove();
    });
    if (s.free) {
      root.querySelectorAll('.quick-view-view-product-details-link').forEach((el) => el.remove());
      root.querySelectorAll('a[href*="/products/"]').forEach((el) => el.removeAttribute('href'));
    }
    s.doc.then((doc) => {
      if (session !== s || !doc) return;
      setupHeader(s, doc);
      s.toricStock = window.ECToricStock ? window.ECToricStock.fromDoc(doc, s.handle) : null;
      if ((s.mode === 'variant' || s.mode === 'gift') && visibleProps(s.line.properties).length) {
        injectRx(s, doc);
        setupLens(s);
      }
    });
  });

  const num = (v) => {
    const n = parseFloat(String(v == null ? '' : v).replace('--', '').trim());
    return isNaN(n) ? 0 : n;
  };

  const indexMax = (txt) => {
    if (/NO\s*RX/i.test(txt)) return 0;
    if (/CYL/i.test(txt) || /and\s*above/i.test(txt)) return Infinity;
    const m = txt.match(/to\s*-?\/?\+?\s*(\d+(?:\.\d+)?)/i);
    return m ? parseFloat(m[1]) : Infinity;
  };

  const checkGlassesRx = (s, props) => {
    const keys = Object.keys(props);
    const nonZero = keys.some((k) => /^(sph|cyl|axis)\b/i.test(k) && num(props[k]) !== 0);
    if (nonZero && Object.prototype.hasOwnProperty.call(props, 'PD')) {
      const pd = String(props.PD || '').trim();
      if (!pd || pd === '--' || /^(na|n\/?a|none)\b/i.test(pd)) return t('pd');
    }
    if (s.lens && s.lens.blocked) return t('rx-range');
    return '';
  };

  const checkToricStock = (s, props) => {
    if (!s.toricStock || !window.ECToricStock) return '';
    const res = window.ECToricStock.checkProps(s.toricStock, props, s.line.quantity);
    return res.ok ? '' : window.ECToricStock.msg(res.code);
  };

  const optionSelect = (root, name) => Array.from(root.querySelectorAll('select[name^="options["]'))
    .find((el) => (el.getAttribute('name') || '').toLowerCase() === 'options[' + name.toLowerCase() + ']');

  const isDemo = (v) => /NO\s*RX/i.test(v);
  const isSpecial = (v) => /CYL/i.test(v) && !/NO\s*RX/i.test(v);
  const TINT_TYPES = ['Blush Tint'];
  const typeParts = (v) => String(v).split(' + ');
  const isTint = (v) => typeParts(v).some((part) => TINT_TYPES.some((name) => part.indexOf(name) === 0));

  const setupLens = async (s) => {
    const root = s.root;
    if (!root || session !== s) return;
    const idxSel = optionSelect(root, 'Lens index');
    const typeSel = optionSelect(root, 'Lens type');
    if (!idxSel || !typeSel || !root.querySelector('[data-ec-cart-edit-prop]')) return;
    const product = await fetch(ROOT() + 'products/' + s.handle + '.js').then((r) => r.json()).catch(() => null);
    if (!product || session !== s) return;
    const names = product.options.map((o) => String(o.name || o).toLowerCase());
    const idxPos = names.indexOf('lens index') + 1;
    const typePos = names.indexOf('lens type') + 1;
    const colorPos = [1, 2, 3].find((p) => p !== idxPos && p !== typePos && p <= names.length) || 0;
    const colorSel = colorPos ? root.querySelector('select[name="options[' + product.options[colorPos - 1].name + ']"]') : null;
    const indexValues = Array.from(idxSel.options).map((o) => o.value);
    const typeValues = Array.from(typeSel.options).map((o) => o.value);
    const ladder = indexValues.filter((v) => !isDemo(v) && !isSpecial(v));
    const specialVal = indexValues.find(isSpecial) || null;

    const rx = () => {
      const vals = {};
      root.querySelectorAll('[data-ec-cart-edit-prop]').forEach((el) => { vals[el.getAttribute('data-ec-cart-edit-prop')] = el.value; });
      const pick = (re) => Object.keys(vals).filter((k) => re.test(k)).map((k) => Math.abs(num(vals[k])));
      const sph = pick(/^sph\b/i), cyl = pick(/^cyl\b/i), axis = pick(/^axis\b/i);
      const addRaw = String(vals.Add || '');
      const maxSph = sph.length ? Math.max.apply(null, sph) : 0;
      const maxCyl = cyl.length ? Math.max.apply(null, cyl) : 0;
      const anyRx = maxSph > 0 || maxCyl > 0 || axis.some((a) => a !== 0) || (addRaw !== '' && addRaw !== '--' && num(addRaw) !== 0);
      return { maxSph, maxCyl, anyRx };
    };
    const hasAdd = () => Array.from(root.querySelectorAll('[data-ec-cart-edit-prop]'))
      .some((el) => /^Add\b/.test(el.getAttribute('data-ec-cart-edit-prop')) && num(el.value) !== 0);
    const color = () => (colorSel ? colorSel.value : null);
    const findVar = (idx, type) => product.variants.find((v) => v.available
      && v['option' + idxPos] === idx && v['option' + typePos] === type
      && (!colorPos || !color() || v['option' + colorPos] === color()));
    const idxHasStock = (idx) => product.variants.some((v) => v.available && v['option' + idxPos] === idx
      && (!colorPos || !color() || v['option' + colorPos] === color()));
    const rules = () => {
      const r = rx();
      return { r, tintOff: hasAdd(), cylForcesSpecial: !!specialVal && r.maxCyl > 2 && idxHasStock(specialVal) };
    };
    const idxAllowed = (val, ru) => {
      if (ru.cylForcesSpecial) return isSpecial(val);
      if (isDemo(val)) return !ru.r.anyRx;
      if (isSpecial(val)) return true;
      return indexMax(val) >= ru.r.maxSph;
    };
    const resolveIndexFor = (type, ru) => {
      if (ru.tintOff && isTint(type)) return null;
      if (ru.cylForcesSpecial) return findVar(specialVal, type) ? specialVal : null;
      const cur = idxSel.value;
      if (cur && idxAllowed(cur, ru) && findVar(cur, type)) return cur;
      const hit = ladder.find((v) => idxAllowed(v, ru) && findVar(v, type));
      if (hit) return hit;
      if (specialVal && findVar(specialVal, type)) return specialVal;
      return null;
    };
    const markOption = (sel, val, off) => {
      const opt = Array.from(sel.options).find((o) => o.value === val);
      if (opt) opt.disabled = off;
      const group = sel.closest('.product__option');
      const btn = group && Array.from(group.querySelectorAll('[data-option-value]')).find((b) => b.getAttribute('data-option-value') === val);
      if (btn) {
        btn.toggleAttribute('disabled', off);
        if (off) btn.classList.add('disabled');
      }
    };
    const paint = () => {
      const ru = rules();
      indexValues.forEach((v) => markOption(idxSel, v, !(idxAllowed(v, ru) && findVar(v, typeSel.value))));
      typeValues.forEach((v) => markOption(typeSel, v, resolveIndexFor(v, ru) === null));
    };
    let busy = false;
    const refresh = () => {
      if (busy || session !== s) return;
      busy = true;
      const ru = rules();
      const prevType = typeSel.value, prevIdx = idxSel.value;
      let target = resolveIndexFor(typeSel.value, ru);
      if (target === null) {
        const order = ru.tintOff && isTint(typeSel.value)
          ? typeParts(typeSel.value).concat(typeValues.filter((v) => /^Standard\b/i.test(v)), typeValues)
          : typeValues;
        const alt = order.find((v) => typeValues.indexOf(v) !== -1 && resolveIndexFor(v, ru) !== null);
        if (alt) { typeSel.value = alt; target = resolveIndexFor(alt, ru); }
      }
      s.lens.blocked = target === null;
      if (target !== null) idxSel.value = target;
      if (typeSel.value !== prevType) typeSel.dispatchEvent(new Event('change', { bubbles: true }));
      if (idxSel.value !== prevIdx) idxSel.dispatchEvent(new Event('change', { bubbles: true }));
      busy = false;
      syncPd();
      setTimeout(paint, 0);
      if (s.lens.blocked) showError(t('rx-range'));
      else if (ru.tintOff && isTint(prevType) && !isTint(typeSel.value)) showError(t('add-tint'));
      else clearError();
    };
    const tintClash = (vid) => {
      if (!hasAdd()) return false;
      const v = product.variants.find((x) => x.id === vid);
      return isTint(typeSel.value) || !!(v && isTint(v['option' + typePos]));
    };
    const NA_PD = 'N/A (for NON-PRESCRIPTION glasses ONLY)';
    const pdSel = root.querySelector('[data-ec-cart-edit-prop="PD"]');
    const syncPd = () => {
      if (!pdSel) return;
      const rxOn = Array.from(root.querySelectorAll('[data-ec-cart-edit-prop]'))
        .some((el) => /^(sph|cyl|axis)\b/i.test(el.getAttribute('data-ec-cart-edit-prop')) && num(el.value) !== 0);
      const naOpts = Array.from(pdSel.options).filter((o) => /^(na|n\/?a|none)\b/i.test(o.value.trim()));
      if (!rxOn) {
        let na = naOpts[0];
        if (!na) {
          na = document.createElement('option');
          na.value = NA_PD;
          na.textContent = NA_PD;
          pdSel.insertBefore(na, pdSel.firstChild);
        }
        pdSel.value = na.value;
        pdSel.disabled = true;
        return;
      }
      pdSel.disabled = false;
      const wasNa = naOpts.some((o) => o.value === pdSel.value);
      naOpts.forEach((o) => o.remove());
      if (wasNa || !pdSel.value) {
        let blank = Array.from(pdSel.options).find((o) => o.value === '');
        if (!blank) {
          blank = document.createElement('option');
          blank.value = '';
          blank.textContent = '--';
          pdSel.insertBefore(blank, pdSel.firstChild);
        }
        pdSel.value = '';
      }
    };
    s.lens = { blocked: false, refresh, tintClash };
    root.addEventListener('change', (e) => {
      if (session !== s || busy) return;
      if (e.target.hasAttribute('data-ec-cart-edit-prop') || e.target === typeSel || e.target === idxSel) refresh();
      else setTimeout(paint, 0);
    });
    root.addEventListener('click', (e) => {
      if (e.target.closest && e.target.closest('.product__color-swatch, [data-option-value]')) setTimeout(refresh, 60);
    });
    refresh();
  };

  const findPairGroup = (cart, line, rId, lId, rT, lT, exclude) => {
    const match = cart.items.find((i) => {
      const p = i.properties || {};
      return i.product_id === line.product_id && i.variant_id === rId && p._eye === 'R'
        && p['Power R'] === rT && p['Power L'] === lT
        && p._pair_id !== undefined && String(p._pair_id) !== String(exclude);
    });
    if (!match) return null;
    const gid = match.properties._pair_id;
    const partner = cart.items.find((i) => i.properties && String(i.properties._pair_id) === String(gid)
      && i.properties._eye === 'L' && i.variant_id === lId);
    return partner ? gid : null;
  };

  const buildPlan = (s) => {
    const root = s.root;
    const line = s.line;
    const plan = sellingPlan(line);

    if (s.mode === 'pair') {
      const sels = root.querySelectorAll('.variant-picker-pairs select');
      if (sels.length !== 2) return null;
      const rOpt = sels[0].options[sels[0].selectedIndex];
      const lOpt = sels[1].options[sels[1].selectedIndex];
      const rId = Number(sels[0].value), lId = Number(sels[1].value);
      if (!rId || !lId || !rOpt || !lOpt) return null;
      const rT = rOpt.dataset.title, lT = lOpt.dataset.title;
      const legacy = s.pair.pid === null;
      if (rId === s.pair.rId && lId === s.pair.lId) return null;

      const extras = {};
      Object.keys(s.pair.base.properties || {}).forEach((k) => {
        if (PAIR_KEYS.indexOf(k) === -1) extras[k] = s.pair.base.properties[k];
      });
      const pid = findPairGroup(s.cart, line, rId, lId, rT, lT, s.pair.pid) || (legacy ? Date.now() : s.pair.pid);
      const mk = (id, eye) => {
        const properties = Object.assign({ 'Power R': rT, 'Power L': lT, '_pair': 'true', '_pair_id': pid, '_eye': eye }, extras);
        const item = { id, quantity: s.pair.qty, properties };
        if (plan) item.selling_plan = plan;
        return item;
      };
      return { items: [mk(rId, 'R'), mk(lId, 'L')], remove: s.pair.group };
    }

    const form = root.querySelector('form[data-product-form]') || root.querySelector('form[action*="/cart/add"]');
    const idEl = form && form.querySelector('[name="id"]');
    const vid = Number(idEl && idEl.value) || line.variant_id;
    const props = Object.assign({}, line.properties || {});
    if (s.mode === 'variant' || s.mode === 'gift') {
      root.querySelectorAll('[data-ec-cart-edit-prop]').forEach((sel) => {
        props[sel.getAttribute('data-ec-cart-edit-prop')] = sel.value;
      });
    }
    if (vid === line.variant_id && sameProps(props, line.properties)) return null;
    if (s.mode === 'variant') {
      if (s.lens && s.lens.tintClash(vid)) {
        s.lens.refresh();
        const e = new Error('rx');
        e.userMessage = t('add-tint');
        throw e;
      }
      const err = checkGlassesRx(s, props) || checkToricStock(s, props);
      if (err) {
        const e = new Error('rx');
        e.userMessage = err;
        throw e;
      }
    }
    const item = { id: vid, quantity: line.quantity, properties: props };
    if (plan) item.selling_plan = plan;
    return { items: [item], remove: [line] };
  };

  const finish = (s, cart) => {
    const utils = typeof UTILS !== 'undefined' ? UTILS : null;
    if (s.ctx === 'drawer' && utils && utils.EcCart) {
      utils.EcCart.refreshCart({ reloadOnCartPage: false });
      return;
    }
    window.r$1('quick-view:close');
    window.r$1('quick-cart:updated');
    window.r$1('cart:updated', { cart });
  };

  const confirmEdit = async (btn) => {
    const s = session;
    if (!s || s.busy) return;
    clearError();
    let plan;
    try {
      plan = buildPlan(s);
    } catch (err) {
      showError(err && err.userMessage);
      return;
    }
    if (!plan) {
      window.r$1('quick-view:close');
      return;
    }
    s.busy = true;
    if (btn) btn.classList.add('loading');
    try {
      if (typeof UTILS !== 'undefined' && UTILS.EcCart) {
        const res = await UTILS.EcCart.addItems(plan.items);
        if (!res.ok) {
          const err = new Error('cart request failed');
          err.userMessage = t('stock');
          throw err;
        }
      } else {
        await postJSON('cart/add.js', { items: plan.items });
      }
      let cart = await getCart();
      for (const old of plan.remove) {
        let remaining = old.quantity;
        for (let guard = 0; remaining > 0 && guard < 8; guard++) {
          const hit = cart.items.find((i) => i.variant_id === old.variant_id && sameProps(i.properties, old.properties));
          if (!hit) break;
          const take = Math.min(hit.quantity, remaining);
          cart = await postJSON('cart/change.js', { id: hit.key, quantity: hit.quantity - take });
          remaining -= take;
        }
      }
      if (btn) btn.classList.remove('loading');
      finish(s, cart);
    } catch (err) {
      if (btn) btn.classList.remove('loading');
      s.busy = false;
      showError(err && err.userMessage);
    }
  };

  const trigger = (target) => {
    if (!target || !target.closest || target.closest('a, input, select, textarea')) return null;
    return target.closest('[data-ec-cart-edit]');
  };

  document.addEventListener('click', (e) => {
    const el = trigger(e.target);
    if (!el) return;
    e.preventDefault();
    start(el);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const el = trigger(e.target);
    if (!el || el !== e.target) return;
    e.preventDefault();
    start(el);
  });

  const editButton = (target) => {
    if (!session || !session.root || !target || !target.closest) return null;
    const btn = target.closest('[name="add"]');
    return btn && session.root.contains(btn) ? btn : null;
  };

  window.addEventListener('click', (e) => {
    const btn = editButton(e.target);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    confirmEdit(btn);
  }, true);

  window.addEventListener('submit', (e) => {
    if (!session || !session.root || !session.root.contains(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    confirmEdit(session.root.querySelector('[name="add"]'));
  }, true);
})();
